import { Options } from "@antv/g2plot/lib/types/common";
/**
 * Partial visualisation configuration
 */
export const PARTIAL_VISUALISATION_CONFIGURATION: Partial<Options> = {
    animation: false,
};
